import { Shared_FormTemplate_QuestionFragment } from "./fragments/fragments.generated";

// export type FormField = Shared_FormTemplate_QuestionFragment & {
//     value: string | null;
// };

// export const FormField: {
//     create: (field: Shared_FormTemplate_QuestionFragment, value: string | null) => FormField;
// } = {
//     create(field, value) {
//         return { ...field, value };
//     },
// };

export type NarrowedFormField<T extends Shared_FormTemplate_QuestionFragment["type"]> =
    Shared_FormTemplate_QuestionFragment & {
        type: T;
    };

export const NarrowedFormField: {
    create: <T extends Shared_FormTemplate_QuestionFragment["type"]>(
        field: Shared_FormTemplate_QuestionFragment,
        type: T,
    ) => NarrowedFormField<T>;
} = {
    create(field, type) {
        return { ...field, type };
    },
};
